import { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

type Props = {
    wrapperClassName?: string;
    text?: string;
};

const NoData: FC<Props> = ({ wrapperClassName, text }) => {
    const { t } = useTranslation();

    return (
        <div className={classNames("no-data", wrapperClassName)}>
            {text ? text : `${t("no_data")} ...`}
        </div>
    );
};

export default NoData;
